import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, Validators } from '@angular/forms';
import { DatabaseService } from 'src/app/services/database.service';

@Component({
    selector: 'app-add-cp-gen2-notification',
    templateUrl: './add-cp-gen2-notification.component.html',
    styleUrls: ['./add-cp-gen2-notification.component.scss'],
    standalone: false
})
export class AddCpGen2NotificationComponent {

  form: any;
  processing = false;

  // ✅ Quill config (replacement of AngularEditorConfig)
  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline'],

      [{ header: [1, 2, 3, false] }],

      [{ list: 'ordered' }, { list: 'bullet' }],

      [{ indent: '-1' }, { indent: '+1' }],

      [{ color: [] }, { background: [] }],

      [{ align: [] }],

      ['link', 'image'],

      ['clean']
    ]
  };

  editorPlaceholder = 'Enter text here...';

  constructor(
    private dialogRef: MatDialogRef<AddCpGen2NotificationComponent>,
    private fb: FormBuilder,
    private db: DatabaseService
  ) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      message: ['', Validators.required],
      app: ['0', Validators.required],
      url: ['', Validators.required],
      version: ['', Validators.required],
      upgrade_message: [false],
      critical: [false],
      testonly: [false]
    });
  }

  ngOnInit(): void {}

  save() {
    if (!this.processing) {
      this.processing = true;

      let ts = Math.round(Date.now() / 1000);
      let platform = 'CpGen2';

      if (this.form.controls.testonly.value) {
        platform = 'isTestOnly/CpGen2';
      }

      this.db.addNotification(platform, 'notification_' + ts, {
        appNewVersion: this.form.controls.version.value,
        date: new Date(),
        isAppUpgradeMessage: this.form.controls.upgrade_message.value,
        isCritical: this.form.controls.critical.value,
        notificationtitle: this.form.controls.title.value,
        notificationmessage: this.form.controls.message.value,
        url: this.form.controls.url.value
      }).then(() => {

        this.db.sendMessage({
          topic: platform,
          notificationtitle: this.form.controls.title.value,
          notificationmessage: this.form.controls.message.value,
        }).subscribe(() => {});

        this.dialogRef.close(true);
        this.processing = false;
      });
    }
  }
}